import React, { FC, useEffect } from 'react';
import _ from 'lodash';
import Title from 'components/common/Title';
import { IRootState } from 'store';
import { getUnitStats } from 'actions/scholars';
import { useDispatch, connect } from 'react-redux';
import styles from './index.module.scss';

const mstp = (state: IRootState) => ({
  unitStats: state.scholars.stats,
});
interface Props extends ReturnType<typeof mstp> {
  anetapackName: string;
  anetapackId: number;
}

const AnetaPackUsage: FC<Props> = ({
  anetapackName,
  anetapackId,
  unitStats,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (anetapackId) {
      dispatch(getUnitStats(anetapackId));
    }
  }, [anetapackId, dispatch]);

  return (
    <div className={styles.usageModal}>
      <Title>Track {anetapackName} Usage</Title>
      <div className={styles.applyTimes}>
        <div>
          <div>{unitStats?.recipients}</div>
          <span>Recipients</span>
        </div>
        <div>
          <div>{unitStats?.timesApplied}</div>
          <span>Times Applied</span>
          <p>
            We will not report back on exactly who has applied it due to privacy
            issues
          </p>
        </div>
      </div>
      <div className={styles.recipient}>
        <span>Recipient Emails:</span>
        <div className={styles.recipientsList}>
          {!_.isEmpty(unitStats?.emails) &&
            unitStats?.emails.map((el) => (
              <div className={styles.recipientsListItem} key={el}>
                <span>{el}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default connect(mstp)(AnetaPackUsage);
